import { Link } from 'react-router-dom';

const legalLinks = [
  { label: 'Conditions générales', to: '/conditions-generales' },
  { label: 'Politique de confidentialité', to: '/confidentialite' },
  { label: 'Informations entreprise', to: '/informations' },
];

const mainLinks = [
  { label: 'Accueil', to: '/' },
  { label: 'À propos', to: '/a-propos' },
  { label: 'Contact', to: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-neutral-50 border-t border-neutral-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-20">
          {/* Brand */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/919c54e0-bd86-457d-a962-43ad1a5aaa7f.png"
              alt="HASPICA"
              className="h-7 w-auto object-contain mb-5"
            />
            <p className="text-sm text-neutral-500 leading-relaxed mb-1">Patrik Haspica</p>
            <p className="text-xs text-neutral-400 leading-relaxed">SIRET&nbsp;: 102 262 441 00011</p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold text-neutral-400 uppercase tracking-widest mb-5">Contact</h4>
            <address className="not-italic space-y-2">
              <p className="text-sm text-neutral-600">12 Rue Judaïque<br />33000 Bordeaux, France</p>
              <a
                href="tel:+33753495245"
                className="block text-sm text-neutral-600 hover:text-neutral-900 transition-colors cursor-pointer"
              >
                +33 7 53 49 52 45
              </a>
              <a
                href="mailto:patr1khaspica@inbox.eu"
                rel="nofollow"
                className="block text-sm text-neutral-600 hover:text-neutral-900 transition-colors cursor-pointer"
              >
                patr1khaspica@inbox.eu
              </a>
            </address>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold text-neutral-400 uppercase tracking-widest mb-5">Navigation</h4>
            <nav className="space-y-2">
              {mainLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block text-sm text-neutral-600 hover:text-neutral-900 transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
              <div className="pt-2 border-t border-neutral-200 mt-3 space-y-2">
                {legalLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="block text-xs text-neutral-400 hover:text-neutral-600 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </nav>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-neutral-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-neutral-400">
            © {new Date().getFullYear()} HASPICA — Tous droits réservés
          </p>
          <p className="text-xs text-neutral-400">
            74.10Z — Activités spécialisées de design
          </p>
        </div>
      </div>
    </footer>
  );
}
